import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type EnhancedTableElements = {
  table: SxProps
  tableMui: SxProps
  headerCell: SxProps
  headerCellText: SxProps
  headerCellSort: SxProps
  noRegistersBox: SxProps
  noRegistersBoxSvg: SxProps
  row: SxProps
  bodyCell: SxProps
  container: SxProps
  requiredText: SxProps
  footer: SxProps
}

export const enhancedTableStyles: EnhancedTableElements = {
  table: {
    '&.modal-variation': {
      border: `1px solid ${theme.colors.main200}`,
      borderRadius: '8px',
      padding: theme.spacing(1.5),

      '& > .MuiToolbar-root': {
        backgroundColor: 'white'
      },

      '& .MuiTableRow-root': {
        minHeight: '20px'
      },

      // '& .MuiTableCell-head': {
      //   lineHeight: 1,
      //   display: 'flex',
      //   fontSize: '0.875rem',
      //   alignItems: 'center',
      //   backgroundColor: '#E5E8F1',
      //   padding: '5px 10px',
      //   color: theme.corporate.primaryColor
      // },

      '& .MuiTableCell-body': {
        // fontWeight: 'normal',
        // fontSize: '0.875rem',
        // lineHeight: 'auto',
        // display: 'flex',
        // alignItems: 'center',
        // padding: '5px 10px',
        overflow: 'hidden'
      }
    },

    '&.form-variation': {
      '& .MuiTableBody-root': {
        borderBottom: `1px solid ${theme.colors.main200}`
      },

      '& .no-register-message-container': {
        color: theme.colors.gray700,
        fontFamily: theme.corporate.primaryFont,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px'
      },

      '& .no-register-message-required': {
        '&:before': {
          position: 'relative',
          content: '"*"',
          fontFamily: theme.corporate.primaryFont,
          fontSize: '18px',
          color: theme.colors.red01
        }
      },

      '&.required-table': {
        // borderColor: theme.corporate.errorColor,
        // backgroundColor: theme.corporate.errorColorLight,

        '& .MuiTableRow-root.MuiTableRow-head': {
          // borderBottomColor: theme.corporate.errorColor,

          '& .MuiTableCell-root.MuiTableCell-head': {
            // color: theme.corporate.errorColor,
            // backgroundColor: theme.corporate.errorColorLight
          }
        },

        '& .no-register-message-container': {
          // color: theme.corporate.errorColor
        }
      },

      '&.document-variation': {
        '& .MuiTableCell-body': {
          alignSelf: 'center'
          // border: 0
          // padding: '10px 4px 10px 16px'
        },

        '& .MuiTableRow-root:not(:last-of-type)': {
          borderBottom: `1px solid ${theme.colors.gray03}`
        },

        '& .MuiTableCell-footer': {
          borderTop: `1px solid ${theme.colors.gray03}`
        }
      }
    },

    '& .MuiTableRow-root': {
      minHeight: '45px',
      borderBottom: `1px solid ${theme.colors.main200}`,

      '&:not(.MuiTableRow-footer):hover': {
        backgroundColor: theme.colors.gray50
      }
    },

    '&.fixed-table': {
      borderCollapse: 'collapse',
      minHeight: '415px',
      // maxHeight: '685px',
      // overflowY: 'auto',

      '& .MuiTableHead-root': {
        position: 'sticky',
        top: 0,
        zIndex: 9
      },

      '& .MuiTableFooter-root': {
        backgroundColor: theme.colors.white01,
        position: 'sticky',
        bottom: 0,
        zIndex: 9
      }
    },

    '& .MuiTableFooter-root': {
      borderBottom: 'none'
    },

    '& .no-register-message-container': {
      borderBottom: `1px solid ${theme.colors.main200}`
    }
  },

  tableMui: {
    marginTop: '12px'
  },

  headerCell: {
    backgroundColor: theme.colors.white01,
    color: theme.corporate.primaryColor,
    padding: theme.spacing(1, 0.5),
    lineHeight: 1,
    borderRightWidth: 0,
    fontFamily: theme.corporate.primaryFont,
    fontWeight: '700',
    fontSize: 14,
    borderBottom: `2px solid ${theme.corporate.primaryColor}`,
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(2)
  },

  headerCellText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    lineHeight: '18px'
  },

  headerCellSort: {
    transition: 'transform 0.3s ease-out',
    opacity: 0,

    '&.Mui-active': {
      opacity: 1
    },

    '& .MuiSvgIcon-root': {
      fontSize: '22px'
    }

    // '& .MuiTableSortLabel-icon': {
    //   opacity: 1
    // }
  },

  noRegistersBox: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '260px',
    fontFamily: theme.corporate.secondaryFont,
    fontSize: '14px',
    color: theme.colors.gray02
  },

  noRegistersBoxSvg: {
    color: theme.colors.blue06,
    '& svg': {
      fontSize: '130px'
    }
  },

  row: {
    cursor: 'pointer',
    '& td': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },

  bodyCell: {
    color: theme.colors.gray14,
    fontFamily: theme.corporate.secondaryFont,
    fontSize: 12,
    padding: theme.spacing(0.5, 1, 0.5, 0.5),
    boxSizing: 'content-box',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    borderBottomWidth: '0px',
    minHeight: 46,

    '& .cellActions': {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',

      '& .MuiIconButton-root': {
        padding: theme.spacing(0.5)
      },

      '& svg': {
        fontSize: '21px',
        fill: theme.corporate.primaryColor
      }
    }
  },

  container: {
    overflowY: 'hidden'
  },

  requiredText: {
    display: 'block',
    minHeight: '18px',
    fontSize: '12px',
    color: theme.corporate.errorColor
  },

  footer: {
    height: 42,
    padding: theme.spacing(1.5, 0, 0, 0),

    '& .MuiTableRow-root.MuiTableRow-footer': {
      border: '0'
    },

    '& .MuiTableCell-footer': {
      border: '0'
    }
  }
}
